<template>
	<div
		ref="wrapper"
		class="layout"
		:class="{
			'is-mobile': isMobileViewport,
		}"
	>
		<slot />
		<div class="l-asport-one-layout">
			<div
				v-if="!isNarrowTaggingTool"
				class="l-asport-one-column -left"
			>
				<slot name="actions-left" />
			</div>
			<div class="l-asport-one-column -main">
				<slot name="media" />
			</div>
			<div
				v-show="isSidebarOpen"
				class="l-asport-one-column -right"
			>
				<slot name="actions" />
			</div>
		</div>

		<transition name="layout__settings">
			<SettingsPageDesktop
				v-if="!isMobileViewport"
				v-show="isTaggingToolSettingsOpen"
				:show-tag-group-create-page="showTagGroupCreatePage"
			/>
		</transition>
	</div>
</template>

<script>
import toggleFullscreen from '../../../util/toggleFullscreen';
import { EVENT, bus } from '@videotools/js/events';
import SettingsPageDesktop from '@videotools/js/one/pages/SettingsPageDesktop';
import { mapGetters, mapActions } from 'vuex';

const events = [EVENT.FULLSCREEN_TOGGLE];

export default {
	name:       'LayoutTaggingTool',
	components: { SettingsPageDesktop },
	data() {
		return {
			settingsActive:             false,
			settingsOpenTagGroupCreate: false,
		};
	},
	computed: {
		...mapGetters({
			isMobileAppleDevice:       'device/isMobileAppleDevice',
			isMobileViewport:          'device/isMobileViewport',
			isNarrowTaggingTool:       'device/isNarrowTaggingTool',
			isTaggingToolSettingsOpen: 'app/isTaggingToolSettingsOpen',
			showTagGroupCreatePage:    'app/showTagGroupCreatePage',
			isSidebarOpen:             'app/isSidebarOpen',
		}),
	},
	watch: {
		isMobileViewport() {
			this.setTaggingToolSettingsOpen(false);
		},
	},
	mounted() {
		// Subscribe to external events
		for (const event of events) {
			bus.subscribe(event, this[`BUS-${event}`]);
		}
	},
	destroyed() {
		// Bus
		for (const event of events) {
			bus.unsubscribe(event, this[`BUS-${event}`]);
		}
	},
	methods: {
		...mapActions({
			setTaggingToolSettingsOpen: 'app/setTaggingToolSettingsOpen',
		}),
		[`BUS-${EVENT.FULLSCREEN_TOGGLE}`]() {
			if (this.isMobileAppleDevice) return;
			toggleFullscreen(this.$root.$el);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.layout {
	position: relative;
	height: 100%;
	display: flex;
	flex-direction: column;
}

// .layout__settings {}

.layout__settings-enter-active,
.layout__settings-leave-active {
	transition: opacity $trans-time-fast, transform $trans-time-fast;
}

.layout__settings-enter,
.layout__settings-leave-to {
	opacity: 0;
	transform: scale(0.8);
}
</style>
